/* Lockett Labs Events: Who's trading.
   Every trader at a show: sponsors by level, then everyone, with search,
   categories and sorting. Server-rendered lists (from each show's entry)
   show straight away; the desk's live list replaces them when it answers. */
(function () {
  'use strict';
  var EV = window.EV;
  var root = document.querySelector('[data-ev-dir]');
  if (!EV || !root) return;
  var el = EV.el;
  var API = EV.apiBase(root.getAttribute('data-api') || '');
  var shows = [];
  try { shows = JSON.parse(root.querySelector('[data-dir-shows]').textContent || '[]'); } catch (e) { shows = []; }
  var $ = function (s) { return root.querySelector(s); };
  var state = { show: null, list: [], q: '', cat: '', sort: 'tier' };
  var live = {};

  function pick() {
    var want = new URLSearchParams(location.search).get('show');
    var h = shows.filter(function (s) { return s.handle === want; })[0];
    if (!h) h = shows.filter(function (s) { return s.handle === root.getAttribute('data-next'); })[0];
    if (!h) h = shows.filter(function (s) { return !s.past; })[0] || shows[shows.length - 1];
    return h || null;
  }

  function tabs() {
    var box = $('[data-dir-tabs]');
    box.textContent = '';
    shows.forEach(function (s) {
      var n = (live[s.handle] || s.vendors).length;
      var b = el('button', { type: 'button', role: 'tab', class: 'evdir-tab' + (s.past ? ' is-past' : ''), 'aria-selected': state.show && state.show.handle === s.handle ? 'true' : 'false' },
        el('span', { class: 'evdir-tab__date' }, el('b', { text: s.day }), el('span', { text: s.mon })),
        el('span', { class: 'evdir-tab__tx' }, el('b', { text: s.title }), el('small', { text: (s.past ? 'Who traded' : s.date) + (n ? ' · ' + n + (n === 1 ? ' trader' : ' traders') : '') })));
      b.addEventListener('click', function () { choose(s); });
      box.append(b);
    });
    box.hidden = shows.length < 2;
  }

  function choose(s) {
    state.show = s;
    state.cat = '';
    state.q = '';
    $('[data-dir-q]').value = '';
    try {
      var p = new URLSearchParams(location.search);
      if (location.hostname === 'events.lockett-labs.com') {
        // the events site's own address for this show's traders
        p.delete('show');
        var base = /^\/_preview(\/|$)/.test(location.pathname) ? '/_preview' : '';
        var qs = p.toString();
        history.replaceState(null, '', base + '/' + s.handle + '/traders' + (qs ? '?' + qs : '') + location.hash);
      } else {
        p.set('show', s.handle);
        history.replaceState(null, '', location.pathname + '?' + p.toString() + location.hash);
      }
    } catch (e) { /* ignore */ }
    state.list = (live[s.handle] || s.vendors.map(EV.vendorFrom)).filter(function (v) { return v.name; });
    tabs();
    paint();
    if (API && !live[s.handle]) {
      EV.api(API, 'public.php?action=vendors&handle=' + encodeURIComponent(s.handle)).then(function (d) {
        var list = (d.vendors || []).map(EV.vendorFrom);
        if (!list.length && s.vendors.length) return;
        live[s.handle] = list;
        if (state.show === s) { state.list = list; tabs(); paint(); }
      }).catch(function () { /* the server-rendered list stands */ });
    }
  }

  function open(v) {
    var s = state.show;
    EV.vendorDialog(v, { event: s ? s.title : '', url: location.href.split('#')[0], campaign: s ? s.handle : 'traders' });
  }

  function paint() {
    var s = state.show;
    var head = $('[data-dir-show]');
    head.textContent = '';
    if (s) {
      head.append(el('a', { class: 'evdir-show__card', href: s.url },
        s.image ? el('img', { src: s.image, alt: '', loading: 'lazy' }) : el('span', { class: 'evdir-show__ph' }, EV.icon('nut')),
        el('span', null, el('small', { text: s.past ? 'Who traded at' : 'Trading at' }), el('b', { text: s.title }), el('span', { text: [s.date, s.venue].filter(Boolean).join(' · ') })),
        EV.icon('ext')));
    }
    var list = state.list;
    var sp = EV.vendorSort(list.filter(function (v) { return v.tier; }));
    var cats = {};
    list.forEach(function (v) { v.categories.forEach(function (c) { cats[c] = (cats[c] || 0) + 1; }); });
    var stats = $('[data-dir-stats]');
    stats.textContent = '';
    if (list.length) {
      stats.append(stat(list.length, list.length === 1 ? 'trader' : 'traders'), stat(sp.length, sp.length === 1 ? 'sponsor' : 'sponsors'), stat(Object.keys(cats).length, 'categories'));
    }
    var spSec = $('[data-dir-spons-sec]');
    var spBox = $('[data-dir-spons]');
    spBox.textContent = '';
    sp.forEach(function (v) { spBox.append(EV.sponsorCard(v, open)); });
    spSec.hidden = !sp.length;

    var chips = $('[data-dir-chips]');
    chips.textContent = '';
    var keys = Object.keys(cats).sort(function (a, b) { return cats[b] - cats[a] || a.localeCompare(b); });
    if (keys.length > 1) {
      var mk = function (k, label, n) {
        var b = el('button', { type: 'button', class: 'ev-chip', 'aria-pressed': state.cat === k ? 'true' : 'false' }, label, n ? el('small', { text: ' ' + n }) : null);
        b.addEventListener('click', function () { state.cat = state.cat === k ? '' : k; paint(); });
        return b;
      };
      chips.append(mk('', 'Everything', 0));
      keys.forEach(function (k) { chips.append(mk(k, k, cats[k])); });
    }
    grid();
    $('[data-dir-none]').hidden = !!list.length;
    $('.evdir-all .evdir-bar').hidden = !list.length;
  }
  function stat(n, label) { return el('span', { class: 'evdir-stat' }, el('b', { text: String(n) }), label); }

  function grid() {
    var q = state.q.trim().toLowerCase();
    var list = state.list.filter(function (v) {
      if (state.cat && v.categories.indexOf(state.cat) === -1) return false;
      if (q && (v.name + ' ' + v.categories.join(' ') + ' ' + v.blurb).toLowerCase().indexOf(q) === -1) return false;
      return true;
    });
    if (state.sort === 'az') list.sort(function (a, b) { return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }); });
    else if (state.sort === 'table') list.sort(function (a, b) { return (a.zone || '~').localeCompare(b.zone || '~') || (a.table || '~').localeCompare(b.table || '~', 'en', { numeric: true }) || a.name.localeCompare(b.name); });
    else list = EV.vendorSort(list);
    var box = $('[data-dir-grid]');
    box.textContent = '';
    var lastZone = null;
    list.forEach(function (v) {
      if (state.sort === 'table' && (v.zone || 'Elsewhere') !== lastZone) {
        lastZone = v.zone || 'Elsewhere';
        box.append(el('h3', { class: 'evdir-zone', text: lastZone }));
      }
      box.append(EV.vendorCard(v, open));
    });
    var t = $('[data-dir-all-title]');
    t.textContent = state.q || state.cat ? list.length + ' of ' + state.list.length + ' traders' : 'Every trader';
    $('[data-dir-empty]').hidden = !!list.length || !state.list.length;
  }

  var qt = null;
  $('[data-dir-q]').addEventListener('input', function (e) { clearTimeout(qt); qt = setTimeout(function () { state.q = e.target.value; grid(); }, 120); });
  $('[data-dir-sort]').addEventListener('change', function (e) { state.sort = e.target.value; grid(); });
  $('[data-dir-share]').addEventListener('click', function () {
    var s = state.show;
    EV.share({ url: location.href.split('#')[0], title: s ? "Who's trading at " + s.title : "Who's trading", text: s ? 'The traders at ' + s.title + (s.date ? ', ' + s.date : '') + '. Plan your day:' : 'The traders at the next Lockett Labs show.', sub: s ? s.date : '', image: s ? s.image : '', hashtags: '#LockettLabs #TCG', campaign: s ? s.handle : 'traders', heading: 'Share the trader list' });
  });

  state.show = pick();
  if (state.show) choose(state.show);
  else { tabs(); paint(); }
})();
